import { useEffect, useState } from "react";

export const useSortIdeas = () => {
  const [sortIdeas, setSortIdeas] = useState({ field: "rating", asc: false });
  const [rowsIdeas, setRowsIdeas] = useState();

  const sortedIdeas = (ideas) => {
    let sortedIdeas = [...ideas];

    switch (sortIdeas.field) {
      case "rating": {
        const green = sortedIdeas.filter((row) => row.status === 3).sort((a, b) => b.rating - a.rating);
        const yellow = sortedIdeas.filter((row) => row.status === 1);
        const red = sortedIdeas.filter((row) => row.status === 2);

        sortedIdeas = [...green, ...yellow, ...red];
        sortIdeas.asc && sortedIdeas.reverse();
        return sortedIdeas;
      }
      case "component":
        sortedIdeas.sort((a, b) => (a?.remoteComponent?.toLowerCase() < b?.remoteComponent?.toLowerCase() ? 1 : -1));
        sortIdeas.asc && sortedIdeas.reverse();
        sortedIdeas = [
          ...sortedIdeas.filter((idea) => idea?.remoteComponent),
          ...sortedIdeas.filter((idea) => !idea?.remoteComponent),
        ];
        return sortedIdeas;
      case "firstAttribute":
        sortedIdeas.sort((a, b) =>
          (a.type === "dependency" && b.type === "dependency"
            ? a.firstAttribute + a.firstComponent
            : ""
          ).toLowerCase() <
          (a.type === "dependency" && b.type === "dependency" ? b.firstAttribute + b.firstComponent : "").toLowerCase()
            ? 1
            : -1,
        );
        sortIdeas.asc && sortedIdeas.reverse();
        sortedIdeas = [
          ...sortedIdeas.filter((idea) => idea.firstAttribute),
          ...sortedIdeas.filter((idea) => !idea.firstAttribute),
        ];
        return sortedIdeas;
      case "secondAttribute":
        sortedIdeas.sort((a, b) =>
          (a.type === "dependency" && b.type === "dependency"
            ? a.secondAttribute + a.secondComponent
            : ""
          ).toLowerCase() <
          (a.type === "dependency" && b.type === "dependency"
            ? b.secondAttribute + b.secondComponent
            : ""
          ).toLowerCase()
            ? 1
            : -1,
        );
        sortIdeas.asc && sortedIdeas.reverse();
        sortedIdeas = [
          ...sortedIdeas.filter((idea) => idea.secondAttribute),
          ...sortedIdeas.filter((idea) => !idea.secondAttribute),
        ];
        return sortedIdeas;
      case "name":
        sortedIdeas.sort((a, b) => (a?.name?.toLowerCase() < b?.name?.toLowerCase() ? 1 : -1));
        sortIdeas.asc && sortedIdeas.reverse();
        sortedIdeas = [...sortedIdeas.filter((idea) => idea.name), ...sortedIdeas.filter((idea) => !idea.name)];
        return sortedIdeas;
      case "project":
        sortedIdeas.sort((a, b) => (a.productName.toLowerCase() < b.productName.toLowerCase() ? 1 : -1));
        sortIdeas.asc && sortedIdeas.reverse();
        return sortedIdeas;
      case "method":
        sortedIdeas.sort((a, b) => (a.type < b.type ? -1 : 1));
        sortIdeas.asc && sortedIdeas.reverse();
        return sortedIdeas;
      case "benefits":
        sortedIdeas.sort((a, b) =>
          a?.benefits?.filter((benefit) => benefit.target.length > 0).length >
          b?.benefits?.filter((benefit) => benefit.target.length > 0).length
            ? -1
            : 1,
        );
        sortIdeas.asc && sortedIdeas.reverse();
        sortedIdeas = [
          ...sortedIdeas.filter((idea) => idea?.benefits?.filter((benefit) => benefit.target.length > 0).length),
          ...sortedIdeas.filter((idea) => !idea?.benefits?.filter((benefit) => benefit.target.length > 0).length),
        ];
        return sortedIdeas;
      default:
        console.warn("Couldn't sort field ", sortIdeas.field);
        break;
    }
  };

  const handleSortChangeIdeas = (field) => {
    field === sortIdeas.field ? setSortIdeas({ field, asc: !sortIdeas.asc }) : setSortIdeas({ field, asc: true });
  };

  // TODO: refactor this logic and remove useEffect
  useEffect(() => {
    if (rowsIdeas?.length) {
      setRowsIdeas(sortedIdeas(rowsIdeas));
    }
  }, [sortIdeas]);

  return {
    handleSortChangeIdeas,
    sortIdeas,
    sortedIdeas,
    rowsIdeas,
    setRowsIdeas,
  };
};
